module.exports = __webpack_public_path__ + "img/symbol_9.4f06bba9.png";